import { useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import getXcolumnJson from "./xcolumn/list";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup_portal';
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import TradeWriteMultyPopup from "@/pages/comp/supply/simple_trade/popup/write_multy";
import SearchArea from "./search/index";
import InitDataManageArea from "./init_data_manage";

const TradeListArea = forwardRef((props: any, ref) => {
  const myProps = {
    list: (inData: any) => { },
    ...props,
  };
  const xColumnArr = getXcolumnJson();
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [stu_seq_arr, set_stu_seq_arr] = useState([]);
  const [stu_name_arr, set_stu_name_arr] = useState([]);
  let default_trade_tot_info = {
    "in_money": 0,
    "out_money": 0,
    "in_debt": 0,
    "out_debt": 0,
    "remain_money": 0
  };
  const [trade_tot_info, set_trade_tot_info] = useState(default_trade_tot_info);

  const listAggridRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_date_type": "a_date",
    "s_start_date": DateFunc.get_date_format(new Date(), "Y-m-01"),
    "s_end_date": DateFunc.get_date_format(new Date(), "Y-m-t"),
    "s_cust_par_id": "user",
    "s_cust_par_seq": [],
    "s_addon_cust_name": "1",
    "s_money_sum": "1",

    "trade_tot_info": default_trade_tot_info,
  });

  const setInitData = (inOptObj: any) => {
    if (inOptObj == undefined) { inOptObj = {}; }
    let optObj = {
      "stu_seq_arr": [],
      "stu_name_arr": [],
      "trade_tot_info": default_trade_tot_info,
      ...inOptObj
    };
    set_stu_seq_arr(optObj["stu_seq_arr"]);
    set_stu_name_arr(optObj["stu_name_arr"]);
    set_trade_tot_info(optObj["trade_tot_info"]);
    list({
      "now_page": "1",
      "s_cust_par_seq": optObj["stu_seq_arr"],
      "trade_tot_info": optObj["trade_tot_info"]
    });
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData
  }));

  useEffect(() => {

  }, []);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "write_multy",//find
    cust_par_seq: "",
    cust_name: "",
    title: "팝업",
    width: "800px",
    height: "80%",
  });

  const list = (inData: any) => {
    let change_listOpt = {
      ...listOpt,
      ...inData
    };
    change_listOpt["sc"] = listAggridRef.current.getListSc();
    setListOpt(change_listOpt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_simple/list', change_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = [...response.data["data"]["info_arr"].reverse()];
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          response.data["data"]["count_info"]["row_view_debt_in"] = strFunc.comma(response.data["data"]["count_info"]["row_view_debt_in"]);
          response.data["data"]["count_info"]["row_view_money_in"] = strFunc.comma(response.data["data"]["count_info"]["row_view_money_in"]);
          response.data["data"]["count_info"]["row_view_remain_total"] = strFunc.comma(response.data["data"]["count_info"]["row_view_remain_total"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
          listAggridRef.current.setPinnedBottomRowData([{
            ...response.data["data"]["count_info"],
            "a_date": "합계"
          },
          {
            "a_date": "총합",
            "row_view_debt_in": strFunc.comma(change_listOpt.trade_tot_info["in_debt"]),
            "row_view_money_in": strFunc.comma(change_listOpt.trade_tot_info["in_money"]),
            "row_view_remain_total": strFunc.comma(change_listOpt.trade_tot_info["remain_money"]),
          }]);

          //마지막 포커스
          setTimeout(() => {
            let row_nodes = listAggridRef.current.getNodeRows();
            listAggridRef.current.setFocusedCell(row_nodes.length - 1, "chk_box");
          }, 100);
        } else {

        }
      });
  };

  const goDelete = (e: any) => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    //걸러내자
    for(let i=0;i<selected_row.length;i++){
      let row_data=selected_row[i];
      if(row_data["a_par_id"]=="class_supply"&&!strFunc.is_empty(row_data["a_par_seq"])){
        alert("청구서관련 데이터는 삭제 할 수 없습니다.(수납관리에서 수정해주세요.)");
        return false;
      }
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_simple/delete', {
      data_arr: selected_row
    }, get_axios_data()).then((response) => {
      if (response.data["result"] === "true") {
        list({});
        myProps.list({});
      } else {
        alert(response.data["msg"]);
      }
    });
  };

  const openWriteMultyPopup = () => {
    if (stu_seq_arr.length != 1) {
      alert("학생 한명만 선택해주세요.");
      return false;
    }
    setPopupData({
      ...popupData,
      "cust_par_seq": stu_seq_arr[0],
      "cust_name": stu_name_arr[0],
      "title": "등록",
      "sort": "write_multy",
      "isOpen": true,
    });
  };

  const cellClickedListener = (params: any) => {
    var key = params.colDef.field;

  };

  const cellRenderer = (params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    if (key == "row_view_money_in") {
      if (params.data.a_inout == "in" && params.data.a_money_type == "money") {
        render_str = params.data.a_money;
        render_str = strFunc.comma(render_str);
      }
    } else if (key == "row_view_debt_in" && params.data.a_money_type == "debt") {
      if (params.data.a_inout == "in") {
        render_str = params.data.a_money;
        render_str = strFunc.comma(render_str);
      }
    }
    return render_str;
  };

  return (
    <div>
      <div className="relative" style={{ minHeight: 55 }}>
        <SearchArea
          listOpt={listOpt}
          list={list}
          openWriteMultyPopup={openWriteMultyPopup}
          goDelete={goDelete}
        ></SearchArea>
        <div>
          거래처: {stu_name_arr.join(", ")}
        </div>
      </div>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: true,
          floatingFilter: false,
          domLayout:'autoHeight',
          onGridReady: () => {
            list({});
          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer
        }}
      ></ListAggrid>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
      <div>
        ※ 미수금 = 청구-입금
      </div>
      <InitDataManageArea
        select_year={listOpt.s_start_date.substr(0, 4)}
        list={list}
      ></InitDataManageArea>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {
            popupData.sort == "write_multy" &&
            <TradeWriteMultyPopup
              cust_par_seq={popupData.cust_par_seq}
              callBackData={() => { list({}); myProps.list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></TradeWriteMultyPopup>
          }
        </LayerPopup>
      }
    </div>
  );
});

export default TradeListArea;